function ContactForm() {
	this.build();
	barbaCallbacks.push(this);
}

ContactForm.prototype.build = function () {
	$('input[name="f_optin_vinci_checkbox[]"]').on('change', function () {
		if ($(this).prop("checked") === true) {
			$('input[name="f_optin_vinci"][value="OUI"]').prop("checked", true);
		} else {
			$('input[name="f_optin_vinci"][value="NON"]').prop("checked", true);
		}
	});
	$('input[name="f_optin_vinci_program_checkbox[]"]').on('change', function () {
		if ($(this).prop("checked") === true) {
			$('input[name="f_optin_vinci_program"][value="OUI"]').prop("checked", true);
		} else {
			$('input[name="f_optin_vinci_program"][value="NON"]').prop("checked", true);
		}
	});
};

